module.exports = __webpack_public_path__ + "static/img/bg_write.e904f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_write.png
// module id = aHa9
// module chunks = 0